/* eslint-disable jsx-a11y/alt-text */
import { useState, useEffect } from "react";
import {
  Input,
  List,
  Typography,
  Card,
  Image,
  Space,
  Button,
  Modal,
  Badge,
  Pagination,
} from "antd";
import "../page/pages.css";
import PageSlider from "../Slider/Slider";
import { useTranslation } from "react-i18next";

const HomeShop = ({ handleClick }) => {
  const { t, i18n } = useTranslation();
  const [searchText, setSearchText] = useState("");
  const [dataSource, setDataSource] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 6, // Number of items per page
    total: 0,
  });

  useEffect(() => {
    setLoading(true);
    const apiUrl = searchText
      ? `https://bardawamplus.com/api/search?q=${searchText}`
      : "https://bardawamplus.com/api/products";

    fetch(apiUrl)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`HTTP error! Status: ${res.status}`);
        }
        return res.json();
      })
      .then((response) => {
        setLoading(false);
        setDataSource(response.data);
        setPagination({ ...pagination, total: response.data.length });
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoading(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText]);

  const onPageChange = (page) => {
    setPagination({ ...pagination, current: page });
  };
  const showItemDetails = (item) => {
    setSelectedItem(item);
    setModalVisible(true);
  };
  const renderData = () => {
    const { current, pageSize } = pagination;
    const startIndex = (current - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    return dataSource.slice(startIndex, endIndex);
  };

  return (
    <div className="font">
      <div className="body-Home">
        <PageSlider />
        <Space style={{ padding: "0px 16px" }} direction="vertical">
          <Input.Search
            className="Search"
            placeholder={t("sent")}
            onSearch={(value) => {
              setSearchText(value);
            }}
            onChange={(e) => setSearchText(e.target.value)}
          ></Input.Search>
          <List
            loading={loading}
            grid={{ xs: 1, sm: 2, md: 2, lg: 3, xl: 3 }}
            dataSource={renderData()}
            // dataSource={dataSource}
            renderItem={(item) => {
              const nameTranslations = JSON.parse(item.name);
              // const descriptionTranslations = JSON.parse(item.description);

              const currentLanguage = i18n.language || "ku";
              const translatedName = nameTranslations[currentLanguage];
              // const translatedDescription =
              //   descriptionTranslations[currentLanguage];
              return (
                <Badge.Ribbon
                  text={t("buy")}
                  color="orange"
                  style={{
                    margin: 9,
                  }}
                >
                  <Card
                    className="itemCard"
                    honorable
                    // honorable="true" // Pass string value instead of boolean
                    style={{
                      fontSize: 20,
                      direction: "rtl",
                      textAlign: "center",
                      fontWeight: "bold",
                    }}
                    title={translatedName}
                    key={item.id}
                    // handleClick={handleClick}
                    cover={
                      item.image_url ? (
                        <Image
                          src={`https://bardawamplus.com/api/storage/${item.image_url}`}
                          className="Image_Card"
                        />
                      ) : null
                    }
                    actions={[
                      <Button type="link" onClick={() => handleClick(item)}>
                        {t("Add_to_cart")}
                      </Button>,

                      <Button
                        type="link"
                        onClick={() => showItemDetails(item)} // Open modal only when clicking the "Info" button
                      >
                        {t("info")}
                      </Button>,
                    ]}
                  >
                    <Card.Meta
                      title={
                        <Typography.Paragraph
                          style={{
                            fontSize: 20,
                            direction: "rtl",
                          }}
                        >
                          {t("product")}: ${item.discounted_price}
                          <Typography.Text
                            delete
                            type="danger"
                            style={{
                              fontSize: 16,
                              direction: "rtl",
                            }}
                          >
                            <span> </span>
                            {parseFloat(item.price).toFixed(0)}
                          </Typography.Text>
                          <Typography.Paragraph
                            style={{
                              fontSize: 20,
                              direction: "rtl",
                            }}
                          >
                            {t("point")}: {item.points}
                          </Typography.Paragraph>
                        </Typography.Paragraph>
                      }
                    ></Card.Meta>
                  </Card>
                </Badge.Ribbon>
              );
            }}
          ></List>
          <Pagination
            style={{ textAlign: "center" }}
            current={pagination.current}
            pageSize={pagination.pageSize}
            total={pagination.total}
            onChange={onPageChange}
          />
          <Modal
            style={{ direction: "rtl" }}
            title={
              selectedItem?.name &&
              JSON.parse(selectedItem?.name)[i18n.language || "ku"]
            }
            open={modalVisible}
            onCancel={() => setModalVisible(false)}
            footer={[
              <Button key="close" onClick={() => setModalVisible(false)}>
                {t("Close")}
              </Button>,
            ]}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <p>
                {selectedItem?.description &&
                  JSON.parse(selectedItem?.description)[i18n.language || "ku"]}
              </p>
              {selectedItem?.image_url && (
                <img
                  style={{ width: "40%" }}
                  src={`https://bardawamplus.com/api/storage/${selectedItem?.image_url}`}
                />
              )}
              {/* <img
                  style={{ width: "40%" }}
                  src={`https://bardawamplus.com/api/storage/${selectedItem?.image_url}`}
                />
              )} */}
            </div>
          </Modal>
        </Space>
      </div>
    </div>
  );
};

export default HomeShop;
